/**
 * A custom library for scrolling up and down the contents of a block
 *
 * For using you need just add "initScrollItem.init('#element-id', 10000);" in your functionality
 * - First parameter it's element id
 * - Second parameter it's scrolling speed from top to bottom
 *
 * The animation works until you move the mouse to the current block,
 * if you pick up the mouse then the animation will continue.
 *
 * REFACTOR: Convert it to AngularJS directive or find a suitable library.
 * This functionality uses the jqeury library because it is enough,
 * if you have are better ready solutions then you can rewrite it and use your own solution or include some library
 *
 * You can see example in package/graph-head/view/graph/guest/home.phtml:140
 */

window.initScrollItem = {
    speed: 10000,
    way: 'bottom',
    timer: null,
    initHandlers: function () {
        var self = this;

        $(self.className)
            .mouseenter(function () {
                self.item().css({ overflowY: 'scroll' });
                self.item().stop();
                clearInterval(self.timer);
            })
            .mouseleave(function () {
                self.startScroll();
                self.startInterval();
            });
    },
    item: function () {
        return $(this.className);
    },
    getCurrentPosition: function () {
        return this.item().scrollTop();
    },
    itemHeight: function () {
        return this.item().prop('scrollHeight');
    },
    calcSpeedPercent: function () {
        return (100 * this.getCurrentPosition()) / (this.itemHeight() - $(this.className).height());
    },
    startScroll: function () {
        this.item().css({ overflowY: 'hidden' });
        var calcSpeedPercent = this.calcSpeedPercent() + 0.01;
        var calcSpeed = (this.speed * calcSpeedPercent) / 100;

        if (this.way === 'bottom') {
            this.item()
                .stop()
                .animate({ scrollTop: this.itemHeight() }, this.speed - calcSpeed);
        } else {
            this.item().stop().animate({ scrollTop: 0 }, calcSpeed);
        }
    },
    changeScrollWay: function () {
        var currentPosition = this.getCurrentPosition();

        if (currentPosition >= this.itemHeight() - $(this.className).height()) {
            this.way = 'top';
            this.startScroll();
        }

        if (currentPosition <= 0) {
            this.way = 'bottom';
            this.startScroll();
        }
    },
    startInterval: function () {
        var self = this;

        this.timer = setInterval(function () {
            self.changeScrollWay();
        }, this.speed / 20);
    },
    init: function (className, speed) {
        this.className = className;

        if (typeof speed !== 'undefined') {
            this.speed = speed;
        }

        this.initHandlers();
        this.startScroll();

        this.startInterval();
    },
};
